/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style7 = require('antd/lib/pagination/style');

var _pagination = require('antd/lib/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _style8 = require('antd/lib/modal/style');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _style9 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _style10 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _style11 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style12 = require('antd/lib/select/style');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _reactRouter = require('react-router');

var _config = require('util/config');

var _tool = require('util/tool');

require('./index.less');

require('./index.css');

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option;
var sKind = '3';
var role = window.localStorage.getItem("userName");
function handleChange(value) {
  sKind = value;
}

var selectBefore = (0, _jsx3.default)(_select2.default, {
  defaultValue: sKind,
  style: { width: 120 },
  onChange: handleChange
}, void 0, (0, _jsx3.default)(Option, {
  value: '1'
}, void 0, '\u8F66\u578B\u540D\u79F0'), (0, _jsx3.default)(Option, {
  value: '2'
}, void 0, '\u751F\u4EA7\u5382\u5546'), (0, _jsx3.default)(Option, {
  value: '3'
}, void 0, '\u8BBE\u5907ID'));

var limaSelectBefore = (0, _jsx3.default)(_select2.default, {
  defaultValue: sKind,
  style: { width: 120 },
  onChange: handleChange
}, void 0, (0, _jsx3.default)(Option, {
  value: '3'
}, void 0, '\u8BBE\u5907ID'));

var _ref3 = (0, _jsx3.default)('div', {
  className: 'empty'
}, void 0, '\u6682\u65E0\u6570\u636E');

var _ref4 = (0, _jsx3.default)('div', {
  className: 'empty'
}, void 0, '\u6682\u65E0\u6570\u636E');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.onChange = function (pageNumber) {
      var role = window.localStorage.getItem("userName");
      var options = { page: pageNumber, rows: role == ' 嘉为-黄海燕' ? 999 : 6 };
      // let val = this.refs.searchKey.refs.input.value;
      var val = _this.state.val;

      options = val ? (0, _assign2.default)(options, { keywords: val }) : options;

      pageNumber && _this.props.fetchPosts(_config.apiJson.getPagedProductList, options);
    };

    _this.showTotal = function (total) {
      return '\u5171 ' + Math.ceil(total / 6) + ' \u9875';
    };

    _this.handleCancel = function (e) {
      console.log(e);
      _this.setState({
        shows: false
      });
    };

    _this.state = {
      rows: 6,
      datas: [],
      val: '',
      shows: false,
      itemeData: {
        equipmentType: '1',
        accessDeviceType: 102,
        accessDeviceTypeName: "E10",
        accessType: undefined,
        createTime: "2018/09/04 14:20:10",
        deviceCount: 102,
        factoryName: "猛犸充电",
        id: "1234",
        lastUpgradeSubVersionMap: null,
        lastUpgradeTime: null,
        lastUpgradeVersion: null,
        name: "E10",
        networkType: 999,
        operatingSystem: 999,
        partInfoVoList: [],
        pictureUrl: "/resource//PRODUCT_IMAGE/test/2019/0517/7637.png",
        productCode: "12",
        registerNumber: "889180262575",
        remark: "E10很好",
        versionCount: null
      },
      // name属性无意义，是为了方便看出来对应的path分别是哪个页面
      searchResHrefPath: [{
        name: '车的详情页',
        path: '/device/detail'
      }, {
        name: '电池柜详情',
        path: '/device/sbdevice'
      }, {
        name: '电池详情',
        path: '/batterymanagement/batdetail'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      console.log(this.props, 'VIN码 / 车型名称 / 生产厂商');
    }
  }, {
    key: 'equipmentAdd',
    value: function equipmentAdd() {
      this.props.router.push({
        pathname: '/equipment'
      });
    }
  }, {
    key: 'carAdd',
    value: function carAdd() {
      this.props.router.push({
        pathname: '/edit'
      });
    }
  }, {
    key: 'createPruduct',
    value: function createPruduct() {
      this.setState({
        shows: true
      });
    }
  }, {
    key: 'searchKey',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
        var _this2 = this;

        var val, role, fetchData, data, _role;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                val = this.refs.searchKey.refs.input.value, role = window.localStorage.getItem("userName");

                if (val) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', false);

              case 3:
                if (!(role == '立马专属账号' && !/^1851/ig.test(val))) {
                  _context2.next = 6;
                  break;
                }

                _message2.default.error('只能允许1851开头的车架号进行检索!');
                return _context2.abrupt('return');

              case 6:
                fetchData = this.props.fetchData;
                data = fetchData.data.rows || this.state.datas;

                console.log('产品列表的数据----', data);
                if (sKind == 3) {
                  (0, _tool.http)(_config.apiJson.getDeviceIdAndTypeInfo, { deviceId: val }).then(function () {
                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(res) {
                      var resId, pathList;
                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (res) {
                                resId = res.productId;
                                pathList = _this2.state.searchResHrefPath;
                                // 跳转车的详情页

                                if (res.productTemplate == 1 || res.batteryBlone == 1) {
                                  _this2.props.router.push({
                                    pathname: pathList[0].path + '/' + resId + '/' + res.serialNumber
                                  });
                                }
                                // 跳转电池柜的详情页
                                if (res.productTemplate == 2 || res.batteryBlone == 2) {
                                  _this2.props.router.push({
                                    pathname: pathList[1].path + '/' + resId + '/' + res.serialNumber + '/' + res.deviceId
                                  });
                                }
                                // 跳转电池的详情页 【查询的电池不在车中也不再电池柜中的情况】data[0].id就是产品ID默认取产品列表的第一个
                                // 因为这种情况下电池没有归属的产品，所以暂时随便拿一个用。
                                if (res.productTemplate == null && res.batteryBlone == null) {
                                  _this2.props.router.push({
                                    pathname: pathList[2].path + '/' + data[0].id + '/' + res.batteryNumber
                                  });
                                }
                              } else {
                                _message2.default.error('未查询到此设备，请检测查询参数是否正确！');
                              }

                            case 1:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }()).catch(function (res) {
                    var msg = !res.errmsg ? '' + res : res.errmsg;
                    _message2.default.error(msg);
                  });
                } else if (sKind == 4) {
                  (0, _tool.http)(_config.apiJson.getDeviceOrSocketRel, { socketCode: val }).then(function (res) {

                    if (res) {
                      var pro = res.deviceInfo;
                      _this2.props.router.push({
                        pathname: '/device/detail/' + pro.productId + '/' + pro.deviceId
                      });
                    } else {
                      _message2.default.success('未找到插座信息');
                    }
                  }).catch(function (res) {
                    var msg = !res.errmsg ? '' + res : res.errmsg;
                    _message2.default.error(msg);
                  });
                } else {
                  this.setState({
                    val: val
                  });
                  _role = window.localStorage.getItem("userName");

                  val ? this.props.fetchPosts(_config.apiJson.getPagedProductList, { page: 1, rows: _role == ' 嘉为-黄海燕' ? 999 : 6, keywords: val }) : this.props.fetchPosts(_config.apiJson.getPagedProductList, { page: 1, rows: _role == ' 嘉为-黄海燕' ? 999 : 6 });
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function searchKey(_x) {
        return _ref.apply(this, arguments);
      }

      return searchKey;
    }()
  }, {
    key: 'render',
    value: function render() {
      var fetchData = this.props.fetchData;

      var datas = fetchData.data.rows || this.state.datas;
      // datas.push(this.state.itemeData)
      var total = fetchData.data.total || 0;
      var role = window.localStorage.getItem("userName");
      return (0, _jsx3.default)('div', {
        className: 'product-list'
      }, void 0, (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('div', {
        className: 'product-menu'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'product-search'
      }, void 0, _react2.default.createElement(_input2.default, {
        placeholder: role == '立马专属账号' ? '请输入1851开头的车架号' : '硬件SN号 / VIN码 / 设备序列号 / 钢架号',
        style: { width: 450 },
        ref: 'searchKey',
        addonBefore: role == '立马专属账号' ? limaSelectBefore : selectBefore,
        onPressEnter: this.searchKey.bind(this)
      }), (0, _jsx3.default)(_button2.default, {
        className: 'product-search-btn',
        onClick: this.searchKey.bind(this)
      }, void 0, '\u641C\u7D22')), role == ' 嘉为-黄海燕' || role == '15821841762' || role == 'factory1' || role == '立马专属账号' ? '' : (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        className: 'product-create-btn',
        onClick: this.createPruduct.bind(this)
      }, void 0, '\u65B0\u589E\u4EA7\u54C1'), (0, _jsx3.default)(_modal2.default, {
        title: '\u9009\u62E9\u8BBE\u5907',
        visible: this.state.shows,
        onCancel: this.handleCancel.bind(this),
        footer: null,
        className: 'product-create-modal'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'product-create-modals',
        onClick: this.carAdd.bind(this)
      }, void 0, '\u4E24\u8F6E\u7535\u52A8\u8F66'), (0, _jsx3.default)('div', {
        className: 'product-create-modals',
        onClick: this.equipmentAdd.bind(this)
      }, void 0, '\u5176\u4ED6\u8BBE\u5907'))), role == ' 嘉为-黄海燕' || role == '15821841762' ? (0, _jsx3.default)('div', {
        className: 'product-cont'
      }, void 0, datas.map(function (el) {
        //el.pictureUrl = `${el.pictureUrl}`;
        el.accessType = _tool.filter.accessType(el.accessType);
        el.createTime = _tool.tool.formatTime(new Date(el.createTime.replace(/\-/g, '/')));
        if (el.accessDeviceType == 112) {
          return (0, _jsx3.default)(_Item2.default, {
            data: el
          }, el.id);
        }
      }), datas.length == 0 && _ref3) : (0, _jsx3.default)('div', {
        className: 'product-cont'
      }, void 0, datas.map(function (el) {
        //el.pictureUrl = `${el.pictureUrl}`;
        el.accessType = _tool.filter.accessType(el.accessType);
        el.createTime = _tool.tool.formatTime(new Date(el.createTime.replace(/\-/g, '/')));
        return (0, _jsx3.default)(_Item2.default, {
          data: el
        }, el.id);
      }), datas.length == 0 && _ref4), (0, _jsx3.default)('div', {
        className: 'product-page'
      }, void 0, datas.length > 0 && (0, _jsx3.default)(_pagination2.default, {
        total: total,
        showTotal: this.showTotal,
        showQuickJumper: true,
        onChange: this.onChange,
        defaultPageSize: role == ' 嘉为-黄海燕' ? 999 : 6
      }))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: 'productList', //应用关联使用的redux
  component: Main, //接收数据的组件入口
  url: _config.apiJson.getPagedProductList,
  data: { rows: role == ' 嘉为-黄海燕' ? 999 : 6 }
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/list/index.jsx
// module id = 988
// module chunks = 0